<template>
  <div class="api-user-form-page">
    <b-loading :is-full-page="false" :active.sync="isSaving"></b-loading>
    <app-page-header :title="`${apiUserId ? 'Editar' : 'Cadastrar'} Usuário`">
      <button
        v-app-button.icon-left.clear
        v-app-back-button="{ name: 'api-users.index' }"
      >
        <b-icon size="is-small" icon="arrow-left" />Voltar
      </button>
    </app-page-header>
    <app-card>
      <api-user-form
        @submit="onSubmit"
        :id="apiUserId"
        :errors="errors"
        :saving="isSaving"
      ></api-user-form>
    </app-card>
  </div>
</template>

<script>
import ApiUserForm from '@/components/Forms/ApiUserForm.vue';
import ApiUserService from '@/services/api-user.service';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'api-user-form-page',
  mixins: [ToastMixin],
  components: {
    ApiUserForm,
  },
  data: () => {
    return {
      admiapiUserId: null,
      errors: {},
      isSaving: false,
    };
  },
  methods: {
    onSubmit(data) {
      this.errors = {};
      !this.apiUserId && this.save(data);
      this.apiUserId && this.update(this.apiUserId, data);
    },
    save(data) {
      this.isSaving = true;
      ApiUserService.save(data)
        .then(() => {
          this.toastify('Usuário cadastrado com sucesso!');
          this.$router.push({ name: 'api-users.index' });
        })
        .catch(({ response }) => {
          if (response.status === 422) this.errors = response.data.errors;
        })
        .finally(() => (this.isSaving = false));
    },
    update(id, data) {
      this.isSaving = true;
      ApiUserService.update(id, data)
        .then(() => {
          this.toastify('Usuário atualizado com sucesso!');
          this.$router.push({ name: 'api-users.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar atualizar Usuário.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
  },
  beforeMount() {
    this.apiUserId = this.$route.params.id;
  },
};
</script>

<style lang="scss" scoped></style>
